import api from '@/services/api'
import denormalizeJsonApi from '@/utils/denormalizeJsonApi'
import first from 'lodash/first'

export async function loadProject({ commit, dispatch, getters }, projectId) {
    const response = await api.get(`/api/v1/video-projects/${projectId}/clips`);
    const clips = denormalizeJsonApi(response);

    commit('loadProjectSuccess', { id: projectId, clips });
    commit('setClipRanges');
    
    dispatch('jumpToClip', first(getters.clipsInPlayOrder).id);
}

export function finishVideo({ state, getters, dispatch }) {
    dispatch('pause');
    dispatch('jumpToAbsoluteTime', getters.totalOverallTime);
}


export function jumpToClip({ commit, getters }, clipId) {
    commit('jumpToClip', clipId);
}

export function jumpToAbsoluteTime({ commit }, absoluteTime) {
    commit('jumpToAbsoluteTime', absoluteTime);
}

export function updateCurrentVideoAbsoluteTime({ commit }, absoluteTime) {
    commit('updateCurrentVideoAbsoluteTime', absoluteTime);
}

export function jumpToAndPlayClip({ commit, dispatch, getters }, clipId) {
    commit('jumpToClip', clipId);
    dispatch('resume');
}

export function pause({ commit, getters, state }) {
    commit('paused');
}

export function resume({ commit, getters, state }) {
    commit('resumed');
}

export function setFullScreen({ commit }, fullScreen) {
    commit('setFullScreen', fullScreen)
}

export function resetState({ commit }) {
    commit('reset')
}

export function setVolume({ commit }, volume) {
    commit('setVolume', volume)
}

export function mute({ commit }) {
    commit('muted')
}

export function unmute({ commit }) {
    commit('unmuted')
}

export function expandAllClips({ commit }) {
    commit('expandedAllClips')
}

export function unexpandAllClips({ commit }) {
    commit('unexpandedAllClips')
}